import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
    super.initialize();
    this.flashTimeout = null;
  }

  connect() {
    if (this.element.classList.contains('flash-content')) {
      this.flashTimeout = window.setTimeout(() => {
        this.element.classList.remove('flash-content');
      }, 3000);

      this.element.addEventListener('mouseover', () => {
        if (this.flashTimeout) {
          window.clearTimeout(this.flashTimeout);
          this.flashTimeout = null;
        }

        this.element.classList.remove('flash-content');
      });
    }
  }
}
